









import { Component, Vue } from "vue-property-decorator";
import * as d3 from "d3";
import * as moment from "moment";
import { categories, projects } from "../data";
import { Xor } from "../utils";

@Component({})
export default class Home extends Vue {
  email = Xor.decrypt(1337, "Ջ՘ՊՕ՘ՏԗՔՐՕՌՍՐ՗ՖՏՐ՚չ՞Ք՘ՐՕԗ՚ՖՔ");
  mounted() {
    const width = (d3
      .select("#projects")
      .node() as Element).getBoundingClientRect().width;
    const height = width < 800 ? 1200 : 600;
    if (width < 800) {
      this.drawMobile(width, height);
    } else {
      this.drawDesktop(width, height);
    }
    d3.select(window).on("resize", () => {
      const width = (d3
        .select("#projects")
        .node() as Element).getBoundingClientRect().width;
      const height = width < 800 ? 1200 : 600;

      d3.select("#projects")
        .selectAll("*")
        .remove();

      if (width < 800) {
        this.drawMobile(width, height);
      } else {
        this.drawDesktop(width, height);
      }
    });
  }

  drawMobile(width: number, height: number) {
    const rScale = d3
      .scaleSqrt()
      .domain([0, 300])
      .range([10, 120]);

    const svg = d3
      .select("#projects")
      .append("svg")
      .attr("class", "chart")
      .attr("height", height)
      .style("height", height)
      .append("g")
      .attr("transform", `translate(${width / 2}, ${height / 2})`);

    svg
      .selectAll("text")
      .data(d3.keys(categories))
      .enter()
      .append("text")
      .text((d: any) => {
        return d;
      })
      .style("fill", "white")
      .style("text-anchor", "middle")
      .attr("dx", 0)
      .attr("dy", (d: any) => {
        return (categories[d] / 4) * height + 50;
      });

    const div = d3
      .select("body")
      .append("div")
      .attr("class", "tooltip")
      .style("opacity", 0);

    const circles = svg
      .selectAll("circle")
      .data(projects)
      .enter()
      .append("circle")
      .attr("r", (d: any) => {
        return rScale(d.time);
      })
      .attr("fill", (d: any) => {
        const colors = [
          "rgba(91, 192, 235, 1)",
          "rgba(253, 231, 76, 1)",
          "rgba(155, 197, 61, 1)",
          "rgba(229, 89, 52, 1)",
          "rgba(250, 121, 33, 1)"
        ];
        return colors[d.type + 2];
      });

    svg
      .selectAll("circle")
      .call(
        d3
          .drag<any, any>()
          .on("drag", () => {
            d3.event.subject.fx = d3.event.x;
            d3.event.subject.fy = d3.event.y;
          })
          .on("start", () => {
            if (!d3.event.active) simulation.alphaTarget(0.3).restart();
            d3.event.subject.fx = d3.event.subject.x;
            d3.event.subject.fy = d3.event.subject.y;
            div
              .transition()
              .duration(200)
              .style("opacity", 0);
          })
          .on("end", () => {
            if (!d3.event.active) simulation.alphaTarget(0);
            d3.event.subject.fx = null;
            d3.event.subject.fy = null;
          })
      )
      .on("mouseover", (d: any) => {
        div
          .transition()
          .duration(200)
          .style("opacity", 0.9);
        div
          .html(
            `${d.name}<br>${moment
              .duration(d.time, "months")
              .humanize()} of experience`
          )
          .style("left", d3.event.pageX + "px")
          .style("top", d3.event.pageY - 28 + "px");
      })
      .on("mouseout", (d: any) => {
        div
          .transition()
          .duration(500)
          .style("opacity", 0);
      });

    let simulation = d3
      .forceSimulation()
      .force(
        "x",
        d3
          .forceY((d: any) => {
            return (d.type / 4) * height + 200;
          })
          .strength(0.3)
      )
      .force("y", d3.forceX(0).strength(0.02))
      .force(
        "collide",
        d3.forceCollide((d: any) => {
          return rScale(d.time + 2) + 1;
        })
      );

    simulation.nodes(projects).on("tick", () => {
      circles
        .attr("cx", (d: any) => {
          return d.x;
        })
        .attr("cy", (d: any) => {
          return d.y;
        });
    });
  }

  drawDesktop(width: number, height: number) {
    const rScale = d3
      .scaleSqrt()
      .domain([0, 300])
      .range([10, 120]);

    const svg = d3
      .select("#projects")
      .append("svg")
      .attr("class", "chart")
      .attr("height", height)
      .style("height", height)
      .append("g")
      .attr("transform", `translate(${width / 2}, ${height / 2})`);

    const div = d3
      .select("body")
      .append("div")
      .attr("class", "tooltip")
      .style("opacity", 0);

    svg
      .selectAll("text")
      .data(d3.keys(categories))
      .enter()
      .append("text")
      .text((d: any) => {
        return d;
      })
      .style("fill", "white")
      .style("text-anchor", "middle")
      .attr("dy", -height / 2 + 30)
      .attr("dx", (d: any) => {
        return (categories[d] * width) / 7;
      });

    const circles = svg
      .selectAll("circle")
      .data(projects)
      .enter()
      .append("circle")
      .attr("r", (d: any) => {
        return rScale(d.time);
      })
      .attr("fill", (d: any) => {
        const colors = [
          "rgba(91, 192, 235, 1)",
          "rgba(253, 231, 76, 1)",
          "rgba(155, 197, 61, 1)",
          "rgba(229, 89, 52, 1)",
          "rgba(250, 121, 33, 1)"
        ];
        return colors[d.type + 2];
      });

    svg
      .selectAll("circle")
      .call(
        d3
          .drag<any, any>()
          .on("drag", () => {
            d3.event.subject.fx = d3.event.x;
            d3.event.subject.fy = d3.event.y;
          })
          .on("start", () => {
            if (!d3.event.active) simulation.alphaTarget(0.3).restart();
            d3.event.subject.fx = d3.event.subject.x;
            d3.event.subject.fy = d3.event.subject.y;
            div
              .transition()
              .duration(200)
              .style("opacity", 0);
          })
          .on("end", () => {
            if (!d3.event.active) simulation.alphaTarget(0);
            d3.event.subject.fx = null;
            d3.event.subject.fy = null;
          })
      )
      .on("mouseover", (d: any) => {
        div
          .transition()
          .duration(200)
          .style("opacity", 0.9);
        div
          .html(
            `${d.name}<br>${moment
              .duration(d.time, "months")
              .humanize()} of experience`
          )
          .style("left", d3.event.pageX + "px")
          .style("top", d3.event.pageY - 28 + "px");
      })
      .on("mouseout", (d: any) => {
        div
          .transition()
          .duration(500)
          .style("opacity", 0);
      });

    let simulation = d3
      .forceSimulation()
      .force(
        "x",
        d3
          .forceX((d: any) => {
            return (d.type * width) / 7;
          })
          .strength(0.3)
      )
      .force("y", d3.forceY(0).strength(0.02))
      .force(
        "collide",
        d3.forceCollide((d: any) => {
          return rScale(d.time + 2) + 1;
        })
      );

    simulation.nodes(projects).on("tick", () => {
      circles
        .attr("cx", (d: any) => {
          return d.x;
        })
        .attr("cy", (d: any) => {
          return d.y;
        });
    });
  }
}
